import * as ko from 'knockout';
import { BlockUI } from 'Core/Common/BlockUi';
import {Brand} from 'Core/Common/Brand';

import AboutPageTemplate from 'Core/ProfilePage/AboutPage/Templates/AboutPage.html';
ko.templates['Core/ProfilePage/AboutPage/Templates/AboutPage'] = AboutPageTemplate;

export class AboutPage {
	private _isReady: KnockoutObservable<boolean>;

	constructor() {
		this._isReady = ko.observable(true);
	}
	GetTemplateName() {
		return 'Core/ProfilePage/AboutPage/Templates/AboutPage';
	}

	RenderByTargetId(target: string): void {
		ko.cleanNode(document.getElementById(target));
		ko.applyBindings(this, document.getElementById(target));
	}

	AfterRender(el: Array<HTMLElement>) {

	}

	get LogoTitle() {
		if (!Brand.Name) {
			return null;
		}

		const [firstLetter, ...rest] = Brand.Name;
		return `${firstLetter.toUpperCase()}${rest.join('')}`;
	}

	get CompanyInfo() {
		if (Brand.Name === 'spheeres') {
			return '© CyberThing Holding BV, The Netherlands';
		}

		if (Brand.Name === 'corsearch') {
			return '© Corsearch, Inc';
		}

		return null;
	}

	FormatUrl(url: string) {
		return url.replace('{Brand}', Brand.Name);
	}
}